import * as React from 'react';
import { createRef } from 'react';
import { IFocusObserverProps } from './focus-observer.container';
import { PropsWithChildren } from 'react';

import './focus-observer.styles.less';

export class FocusObserver extends React.Component<PropsWithChildren<IFocusObserverProps>> {
    private userInteractionRef = createRef<HTMLDivElement>();
    private previousFocus: boolean = false;

    private handleSetFocus = (event: MouseEvent) => {
        const hasFocus: boolean = !(this.userInteractionRef.current &&
            !this.userInteractionRef.current.contains(event.target as Node));
        if (hasFocus !== this.previousFocus) {
            this.props.setFocus(hasFocus);
            this.previousFocus = hasFocus;
        }
    };

    public componentDidMount() {
        document.addEventListener('mousedown', this.handleSetFocus);
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleSetFocus);
    }

    public render(): JSX.Element {
        return (
            <div ref={this.userInteractionRef} className={'focus-observer'}>
                {this.props.children}
            </div>
        );
    }
}
